import { render, staticRenderFns } from "./AlloyCompareRadar.vue?vue&type=template&id=7958dfba&scoped=true"
import script from "./AlloyCompareRadar.vue?vue&type=script&lang=js"
export * from "./AlloyCompareRadar.vue?vue&type=script&lang=js"
import style0 from "./AlloyCompareRadar.vue?vue&type=style&index=0&id=7958dfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7958dfba",
  null
  
)

export default component.exports